import { getReduxStore } from 'store/storeHolder';
import {
  resetForm as resetBookingForm,
  setStep
} from 'store/reducers/bookingAppointmentSlice';
import { resetForm as resetGiftCardForm } from 'store/reducers/giftCardsShopSlice';
import { guestSessionFinished } from 'store/reducers/guestSlice';
import { resetForm as resetMembershipForm } from 'store/reducers/membershipsSlice';
import { setUserInfo } from 'store/reducers/persistAuthSlice';
import { clearGuestInfo } from 'store/reducers/persistGuestAuthSlice';
import { resetServicesState } from 'store/reducers/servicesSlice';
import {
  authSessionFinished,
  setIsLoading,
  setRedirectFlow
} from 'store/reducers/userSlice';

import { clearPostAuthReturnUrl } from 'utils/postAuthReturnUrl';

import { BookingSteps } from 'types';

let isClearingAuthSession = false;

/** Clears persisted auth and related UI state without resetting RTK Query caches. */
export const clearAuthSession = (): void => {
  if (isClearingAuthSession) {
    return;
  }

  const store = getReduxStore();
  const { userInfo } = store.getState().persistAuth;
  const { guestInfo } = store.getState().persistGuestAuth;

  if (userInfo === null && guestInfo === null) {
    if (store.getState().user.user !== null) {
      store.dispatch(authSessionFinished());
    }
    return;
  }

  isClearingAuthSession = true;

  try {
    if (userInfo !== null) {
      store.dispatch(authSessionFinished());
      store.dispatch(setUserInfo(null));
    }

    if (guestInfo !== null) {
      store.dispatch(guestSessionFinished());
      store.dispatch(clearGuestInfo());
    }

    store.dispatch(setIsLoading(false));
    store.dispatch(setStep(BookingSteps.SERVICE));
    store.dispatch(resetBookingForm());
    store.dispatch(resetGiftCardForm());
    store.dispatch(resetServicesState());
    store.dispatch(setRedirectFlow(null));
    clearPostAuthReturnUrl();
    store.dispatch(resetMembershipForm());
  } finally {
    isClearingAuthSession = false;
  }
};
